import React from "react";
import { darken, readableColor } from "polished";
import { useTheme } from "../../../contexts/ThemeContext";

export const KpiCard = ({ label, value, icon, color }) => {
  const theme = useTheme();
  const baseColor = color || theme.colors?.primary || "#2563eb";
  const cardColor = theme.mode === "dark" ? darken(0.2, baseColor) : baseColor;
  const iconColor = theme.mode === "dark" ? darken(0.3, baseColor) : darken(0.1, baseColor);
  const contrastColor = readableColor(cardColor);

  return (
    <div
      className="flex items-center gap-4 p-[20px] rounded-lg shadow-xl flex-1 min-w-[200px]"
      style={{ backgroundColor: cardColor }}
    >
      {icon && (
        <div
          className="flex items-center justify-center size-14 rounded-full"
          style={{
            backgroundColor: iconColor,
            color: contrastColor,
          }}
        >
          {icon}
        </div>
      )}
      <div>
        <p
          className="text-5xl font-bold leading-none"
          style={{ color: contrastColor }}
        >
          {value}
        </p>
        <p
          className="text-lg font-medium mt-1"
          style={{ color: contrastColor }}
        >
          {label}
        </p>
      </div>
    </div>
  );
};
